<template>
  <div class="sys-header">
    <el-header class="el-header-nav radius">
      <el-menu
        :default-active="activeIndex2"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        :backgroundColor="'#FFFFFF'"
        text-color="#B3B3B3"
        active-text-color="#1890ff"
      >
        <el-menu-item index="1" style="padding: 0 7px 0 10px">
          <li @click="isHeader()" :title="collapse ? $t('header.open') : $t('header.close')">
            <a href="javascript:;">
              <i :class="collapse ? 'el-icon-lock' : 'el-icon-unlock'" style="margin-bottom: 7px"></i>
            </a>
          </li>
        </el-menu-item>

        <el-submenu index="3" style="float: right">
          <template slot="title">
            <el-avatar
              class="hd-img"
              :src="userAvatar"
              style="width: 30px; height: 30px; margin-right: 5px"
            ></el-avatar>
            {{ nickName }}
          </template>
          <el-menu-item index="3-2" @click="handlePassword">{{ $t("header.password") }}</el-menu-item>
          <el-menu-item index="3-3" @click="handleLoginOut">{{ $t("header.loginOut") }}</el-menu-item>
        </el-submenu>
        <el-menu-item index="5" style="float: right; padding: 0 7px 0 10px">
          <li @click="screen()" :title="$t('header.screen')">
            <a href="javascript:;"><i class="el-icon-c-scale-to-original" style="margin-bottom: 4px"></i></a>
          </li>
        </el-menu-item>
      </el-menu>
    </el-header>
  </div>
</template>

<script>
  import screenfull from "screenfull";
  import eventBus from "@/utils/eventBus";

  export default {
    name: "sys-header",
    data() {
      return {
        activeIndex2: "1",
        dialogPassword: false,
        drawer: false
      };
    },
    mounted() {
      eventBus.on("openPasswordDialog", this.handlePassword);
    },
    methods: {
      handleSelect() {},
      isHeader() {
        if (document.body.clientWidth > 1200) {
          this.$store.dispatch("collapse", !this.$store.state.collapse);
        } else {
          this.$message.warning(this.$t("header.width"));
        }
      },
      handlePassword() {
        this.$emit("password", true);
      },
      handleLoginOut() {
        this.$confirm(this.$t("header.isLoginOut"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          if (window.Intercom) {
            window.Intercom("shutdown");
          }
          this.$store.dispatch("loginOut");
          this.$router.push("/login");
        });
      },
      screen() {
        if (screenfull.isEnabled) {
          let that = this;
          screenfull.toggle().then(() => {
            that.$store.commit("INNER_HEIGHT", document.documentElement.clientHeight);
          });
        } else {
          this.$message.warning(this.$t("header.notScreenfull"));
        }
      }
    },
    computed: {
      collapse() {
        return this.$store.state.collapse;
      },
      userAvatar() {
        return this.$store.state.avatar;
      },
      nickName() {
        return this.$store.state.nickName;
      }
    },
    beforeDestroy() {
      eventBus.off("openPasswordDialog", this.handlePassword);
    }
  };
</script>

<style lang="scss">
  .el-header {
    width: 100%;
    padding: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 60px !important;
    line-height: 60px;
    background-color: #fff;
    box-sizing: border-box;
    -webkit-transition: left 0.28s;
    transition: left 0.28s;

    .el-header-nav {
      height: 50px;
      position: relative;
    }

    .el-ul {
      padding: 0 10px;

      li {
        height: 60px;
        float: left;
        line-height: 60px;

        a {
          display: block;
          color: rgb(86, 86, 86);
          padding: 0 15px;
          font-size: 25px;

          .hd-img {
            margin-left: 10px;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
          }
        }

        a:hover {
          color: #409eff;
        }
      }
    }
  }
</style>
